import { StepContent } from './stepContent.types';

export const defaultSavingEstimateContent: StepContent = {
  title: 'Looks like you can save quite a bit!',
  subtitle:
    'Savings are not guaranteed and will vary by case; however, this estimate is based on the information you’ve provided and data from previous patients. Once we receive your specific bills, we will provide a more accurate assessment of your potential savings.',
};
